import { render, staticRenderFns } from "./EditPrinter.vue?vue&type=template&id=45871148"
import script from "./EditPrinter.vue?vue&type=script&lang=js"
export * from "./EditPrinter.vue?vue&type=script&lang=js"
import style0 from "./EditPrinter.vue?vue&type=style&index=0&id=45871148&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports